module.exports = __webpack_public_path__ + "img/921_page_background_people1_pc.c74a4ff8.jpg";